import Axios, { AxiosInstance } from 'axios';

// tslint:disable-next-line: no-empty-interface
export interface IApiClient extends AxiosInstance { }

export function createApiClient(): IApiClient {
    const client = Axios.create({
        baseURL: 'https://api-staging.payhawk.io',
    });

    return client;
}